import { UserPayload } from '@/types/userPayload';
import { atom } from 'jotai';

export const userPrincipalAtom = atom<UserPayload>({} as UserPayload);
